const RawCountriesData = {
  af: {
    name: 'Afghanistan',
    iso2: 'af',
    dialCode: '93',
  },
  al: {
    name: 'Albania',
    iso2: 'al',
    dialCode: '355',
  },
  dz: {
    name: 'Algeria',
    iso2: 'dz',
    dialCode: '213',
  },
  as: {
    name: 'American Samoa',
    iso2: 'as',
    dialCode: '1684',
  },
  ad: {
    name: 'Andorra',
    iso2: 'ad',
    dialCode: '376',
  },
  ao: {
    name: 'Angola',
    iso2: 'ao',
    dialCode: '244',
  },
  ai: {
    name: 'Anguilla',
    iso2: 'ai',
    dialCode: '1264',
  },
  ag: {
    name: 'Antigua and Barbuda',
    iso2: 'ag',
    dialCode: '1268',
  },
  ar: {
    name: 'Argentina',
    iso2: 'ar',
    dialCode: '54',
  },
  am: {
    name: 'Armenia',
    iso2: 'am',
    dialCode: '374',
  },
  aw: {
    name: 'Aruba',
    iso2: 'aw',
    dialCode: '297',
  },
  au: {
    name: 'Australia',
    iso2: 'au',
    dialCode: '61',
  },
  at: {
    name: 'Austria',
    iso2: 'at',
    dialCode: '43',
  },
  az: {
    name: 'Azerbaijan',
    iso2: 'az',
    dialCode: '994',
  },
  bs: {
    name: 'Bahamas',
    iso2: 'bs',
    dialCode: '1242',
  },
  bh: {
    name: 'Bahrain',
    iso2: 'bh',
    dialCode: '973',
  },
  bd: {
    name: 'Bangladesh',
    iso2: 'bd',
    dialCode: '880',
  },
  bb: {
    name: 'Barbados',
    iso2: 'bb',
    dialCode: '1246',
  },
  by: {
    name: 'Belarus',
    iso2: 'by',
    dialCode: '375',
  },
  be: {
    name: 'Belgium',
    iso2: 'be',
    dialCode: '32',
  },
  bz: {
    name: 'Belize',
    iso2: 'bz',
    dialCode: '501',
  },
  bj: {
    name: 'Benin',
    iso2: 'bj',
    dialCode: '229',
  },
  bm: {
    name: 'Bermuda',
    iso2: 'bm',
    dialCode: '1441',
  },
  bt: {
    name: 'Bhutan',
    iso2: 'bt',
    dialCode: '975',
  },
  bo: {
    name: 'Bolivia',
    iso2: 'bo',
    dialCode: '591',
  },
  ba: {
    name: 'Bosnia and Herzegovina',
    iso2: 'ba',
    dialCode: '387',
  },
  bw: {
    name: 'Botswana',
    iso2: 'bw',
    dialCode: '267',
  },
  br: {
    name: 'Brazil',
    iso2: 'br',
    dialCode: '55',
  },
  io: {
    name: 'British Indian Ocean Territory',
    iso2: 'io',
    dialCode: '246',
  },
  vg: {
    name: 'British Virgin Islands',
    iso2: 'vg',
    dialCode: '1284',
  },
  bn: {
    name: 'Brunei',
    iso2: 'bn',
    dialCode: '673',
  },
  bg: {
    name: 'Bulgaria',
    iso2: 'bg',
    dialCode: '359',
  },
  bf: {
    name: 'Burkina Faso',
    iso2: 'bf',
    dialCode: '226',
  },
  bi: {
    name: 'Burundi',
    iso2: 'bi',
    dialCode: '257',
  },
  kh: {
    name: 'Cambodia',
    iso2: 'kh',
    dialCode: '855',
  },
  cm: {
    name: 'Cameroon',
    iso2: 'cm',
    dialCode: '237',
  },
  ca: {
    name: 'Canada',
    iso2: 'ca',
    dialCode: '1',
  },
  cv: {
    name: 'Cape Verde',
    iso2: 'cv',
    dialCode: '238',
  },
  bq: {
    name: 'Caribbean Netherlands',
    iso2: 'bq',
    dialCode: '599',
  },
  ky: {
    name: 'Cayman Islands',
    iso2: 'ky',
    dialCode: '1345',
  },
  cf: {
    name: 'Central African Republic',
    iso2: 'cf',
    dialCode: '236',
  },
  td: {
    name: 'Chad',
    iso2: 'td',
    dialCode: '235',
  },
  cl: {
    name: 'Chile',
    iso2: 'cl',
    dialCode: '56',
  },
  cn: {
    name: 'China',
    iso2: 'cn',
    dialCode: '86',
  },
  co: {
    name: 'Colombia',
    iso2: 'co',
    dialCode: '57',
  },
  km: {
    name: 'Comoros',
    iso2: 'km',
    dialCode: '269',
  },
  cd: {
    name: 'Congo',
    iso2: 'cd',
    dialCode: '243',
  },
  cg: {
    name: 'Congo',
    iso2: 'cg',
    dialCode: '242',
  },
  ck: {
    name: 'Cook Islands',
    iso2: 'ck',
    dialCode: '682',
  },
  cr: {
    name: 'Costa Rica',
    iso2: 'cr',
    dialCode: '506',
  },
  ci: {
    name: 'Côte d’Ivoire',
    iso2: 'ci',
    dialCode: '225',
  },
  hr: {
    name: 'Croatia',
    iso2: 'hr',
    dialCode: '385',
  },
  cu: {
    name: 'Cuba',
    iso2: 'cu',
    dialCode: '53',
  },
  cw: {
    name: 'Curaçao',
    iso2: 'cw',
    dialCode: '599',
  },
  cy: {
    name: 'Cyprus',
    iso2: 'cy',
    dialCode: '357',
  },
  cz: {
    name: 'Czech Republic',
    iso2: 'cz',
    dialCode: '420',
  },
  dk: {
    name: 'Denmark',
    iso2: 'dk',
    dialCode: '45',
  },
  dj: {
    name: 'Djibouti',
    iso2: 'dj',
    dialCode: '253',
  },
  dm: {
    name: 'Dominica',
    iso2: 'dm',
    dialCode: '1767',
  },
  do: {
    name: 'Dominican Republic',
    iso2: 'do',
    dialCode: '1',
  },
  ec: {
    name: 'Ecuador',
    iso2: 'ec',
    dialCode: '593',
  },
  eg: {
    name: 'Egypt',
    iso2: 'eg',
    dialCode: '20',
  },
  sv: {
    name: 'El Salvador',
    iso2: 'sv',
    dialCode: '503',
  },
  gq: {
    name: 'Equatorial Guinea',
    iso2: 'gq',
    dialCode: '240',
  },
  er: {
    name: 'Eritrea',
    iso2: 'er',
    dialCode: '291',
  },
  ee: {
    name: 'Estonia',
    iso2: 'ee',
    dialCode: '372',
  },
  et: {
    name: 'Ethiopia',
    iso2: 'et',
    dialCode: '251',
  },
  fk: {
    name: 'Falkland Islands',
    iso2: 'fk',
    dialCode: '500',
  },
  fo: {
    name: 'Faroe Islands',
    iso2: 'fo',
    dialCode: '298',
  },
  fj: {
    name: 'Fiji',
    iso2: 'fj',
    dialCode: '679',
  },
  fi: {
    name: 'Finland',
    iso2: 'fi',
    dialCode: '358',
  },
  fr: {
    name: 'France',
    iso2: 'fr',
    dialCode: '33',
  },
  gf: {
    name: 'French Guiana',
    iso2: 'gf',
    dialCode: '594',
  },
  pf: {
    name: 'French Polynesia',
    iso2: 'pf',
    dialCode: '689',
  },
  ga: {
    name: 'Gabon',
    iso2: 'ga',
    dialCode: '241',
  },
  gm: {
    name: 'Gambia',
    iso2: 'gm',
    dialCode: '220',
  },
  ge: {
    name: 'Georgia',
    iso2: 'ge',
    dialCode: '995',
  },
  de: {
    name: 'Germany',
    iso2: 'de',
    dialCode: '49',
  },
  gh: {
    name: 'Ghana',
    iso2: 'gh',
    dialCode: '233',
  },
  gi: {
    name: 'Gibraltar',
    iso2: 'gi',
    dialCode: '350',
  },
  gr: {
    name: 'Greece',
    iso2: 'gr',
    dialCode: '30',
  },
  gl: {
    name: 'Greenland',
    iso2: 'gl',
    dialCode: '299',
  },
  gd: {
    name: 'Grenada',
    iso2: 'gd',
    dialCode: '1473',
  },
  gp: {
    name: 'Guadeloupe',
    iso2: 'gp',
    dialCode: '590',
  },
  gu: {
    name: 'Guam',
    iso2: 'gu',
    dialCode: '1671',
  },
  gt: {
    name: 'Guatemala',
    iso2: 'gt',
    dialCode: '502',
  },
  gn: {
    name: 'Guinea',
    iso2: 'gn',
    dialCode: '224',
  },
  gw: {
    name: 'Guinea-Bissau',
    iso2: 'gw',
    dialCode: '245',
  },
  gy: {
    name: 'Guyana',
    iso2: 'gy',
    dialCode: '592',
  },
  ht: {
    name: 'Haiti',
    iso2: 'ht',
    dialCode: '509',
  },
  hn: {
    name: 'Honduras',
    iso2: 'hn',
    dialCode: '504',
  },
  hk: {
    name: 'Hong Kong',
    iso2: 'hk',
    dialCode: '852',
  },
  hu: {
    name: 'Hungary',
    iso2: 'hu',
    dialCode: '36',
  },
  is: {
    name: 'Iceland',
    iso2: 'is',
    dialCode: '354',
  },
  in: {
    name: 'India',
    iso2: 'in',
    dialCode: '91',
  },
  id: {
    name: 'Indonesia',
    iso2: 'id',
    dialCode: '62',
  },
  ir: {
    name: 'Iran',
    iso2: 'ir',
    dialCode: '98',
  },
  iq: {
    name: 'Iraq',
    iso2: 'iq',
    dialCode: '964',
  },
  ie: {
    name: 'Ireland',
    iso2: 'ie',
    dialCode: '353',
  },
  il: {
    name: 'Israel',
    iso2: 'il',
    dialCode: '972',
  },
  it: {
    name: 'Italy',
    iso2: 'it',
    dialCode: '39',
  },
  jm: {
    name: 'Jamaica',
    iso2: 'jm',
    dialCode: '1876',
  },
  jp: {
    name: 'Japan',
    iso2: 'jp',
    dialCode: '81',
  },
  jo: {
    name: 'Jordan',
    iso2: 'jo',
    dialCode: '962',
  },
  kz: {
    name: 'Kazakhstan',
    iso2: 'kz',
    dialCode: '7',
  },
  ke: {
    name: 'Kenya',
    iso2: 'ke',
    dialCode: '254',
  },
  ki: {
    name: 'Kiribati',
    iso2: 'ki',
    dialCode: '686',
  },
  kw: {
    name: 'Kuwait',
    iso2: 'kw',
    dialCode: '965',
  },
  kg: {
    name: 'Kyrgyzstan',
    iso2: 'kg',
    dialCode: '996',
  },
  la: {
    name: 'Laos',
    iso2: 'la',
    dialCode: '856',
  },
  lv: {
    name: 'Latvia',
    iso2: 'lv',
    dialCode: '371',
  },
  lb: {
    name: 'Lebanon',
    iso2: 'lb',
    dialCode: '961',
  },
  ls: {
    name: 'Lesotho',
    iso2: 'ls',
    dialCode: '266',
  },
  lr: {
    name: 'Liberia',
    iso2: 'lr',
    dialCode: '231',
  },
  ly: {
    name: 'Libya',
    iso2: 'ly',
    dialCode: '218',
  },
  li: {
    name: 'Liechtenstein',
    iso2: 'li',
    dialCode: '423',
  },
  lt: {
    name: 'Lithuania',
    iso2: 'lt',
    dialCode: '370',
  },
  lu: {
    name: 'Luxembourg',
    iso2: 'lu',
    dialCode: '352',
  },
  mo: {
    name: 'Macau',
    iso2: 'mo',
    dialCode: '853',
  },
  mk: {
    name: 'Macedonia',
    iso2: 'mk',
    dialCode: '389',
  },
  mg: {
    name: 'Madagascar',
    iso2: 'mg',
    dialCode: '261',
  },
  mw: {
    name: 'Malawi',
    iso2: 'mw',
    dialCode: '265',
  },
  my: {
    name: 'Malaysia',
    iso2: 'my',
    dialCode: '60',
  },
  mv: {
    name: 'Maldives',
    iso2: 'mv',
    dialCode: '960',
  },
  ml: {
    name: 'Mali',
    iso2: 'ml',
    dialCode: '223',
  },
  mt: {
    name: 'Malta',
    iso2: 'mt',
    dialCode: '356',
  },
  mh: {
    name: 'Marshall Islands',
    iso2: 'mh',
    dialCode: '692',
  },
  mq: {
    name: 'Martinique',
    iso2: 'mq',
    dialCode: '596',
  },
  mr: {
    name: 'Mauritania',
    iso2: 'mr',
    dialCode: '222',
  },
  mu: {
    name: 'Mauritius',
    iso2: 'mu',
    dialCode: '230',
  },
  mx: {
    name: 'Mexico',
    iso2: 'mx',
    dialCode: '52',
  },
  fm: {
    name: 'Micronesia',
    iso2: 'fm',
    dialCode: '691',
  },
  md: {
    name: 'Moldova',
    iso2: 'md',
    dialCode: '373',
  },
  mc: {
    name: 'Monaco',
    iso2: 'mc',
    dialCode: '377',
  },
  mn: {
    name: 'Mongolia',
    iso2: 'mn',
    dialCode: '976',
  },
  me: {
    name: 'Montenegro',
    iso2: 'me',
    dialCode: '382',
  },
  ms: {
    name: 'Montserrat',
    iso2: 'ms',
    dialCode: '1664',
  },
  ma: {
    name: 'Morocco',
    iso2: 'ma',
    dialCode: '212',
  },
  mz: {
    name: 'Mozambique',
    iso2: 'mz',
    dialCode: '258',
  },
  mm: {
    name: 'Myanmar',
    iso2: 'mm',
    dialCode: '95',
  },
  na: {
    name: 'Namibia',
    iso2: 'na',
    dialCode: '264',
  },
  nr: {
    name: 'Nauru',
    iso2: 'nr',
    dialCode: '674',
  },
  np: {
    name: 'Nepal',
    iso2: 'np',
    dialCode: '977',
  },
  nl: {
    name: 'Netherlands',
    iso2: 'nl',
    dialCode: '31',
  },
  nc: {
    name: 'New Caledonia',
    iso2: 'nc',
    dialCode: '687',
  },
  nz: {
    name: 'New Zealand',
    iso2: 'nz',
    dialCode: '64',
  },
  ni: {
    name: 'Nicaragua',
    iso2: 'ni',
    dialCode: '505',
  },
  ne: {
    name: 'Niger',
    iso2: 'ne',
    dialCode: '227',
  },
  ng: {
    name: 'Nigeria',
    iso2: 'ng',
    dialCode: '234',
  },
  nu: {
    name: 'Niue',
    iso2: 'nu',
    dialCode: '683',
  },
  nf: {
    name: 'Norfolk Island',
    iso2: 'nf',
    dialCode: '672',
  },
  kp: {
    name: 'North Korea',
    iso2: 'kp',
    dialCode: '850',
  },
  mp: {
    name: 'Northern Mariana Islands',
    iso2: 'mp',
    dialCode: '1670',
  },
  no: {
    name: 'Norway',
    iso2: 'no',
    dialCode: '47',
  },
  om: {
    name: 'Oman',
    iso2: 'om',
    dialCode: '968',
  },
  pk: {
    name: 'Pakistan',
    iso2: 'pk',
    dialCode: '92',
  },
  pw: {
    name: 'Palau',
    iso2: 'pw',
    dialCode: '680',
  },
  ps: {
    name: 'Palestine',
    iso2: 'ps',
    dialCode: '970',
  },
  pa: {
    name: 'Panama',
    iso2: 'pa',
    dialCode: '507',
  },
  pg: {
    name: 'Papua New Guinea',
    iso2: 'pg',
    dialCode: '675',
  },
  py: {
    name: 'Paraguay',
    iso2: 'py',
    dialCode: '595',
  },
  pe: {
    name: 'Peru',
    iso2: 'pe',
    dialCode: '51',
  },
  ph: {
    name: 'Philippines',
    iso2: 'ph',
    dialCode: '63',
  },
  pl: {
    name: 'Poland',
    iso2: 'pl',
    dialCode: '48',
  },
  pt: {
    name: 'Portugal',
    iso2: 'pt',
    dialCode: '351',
  },
  pr: {
    name: 'Puerto Rico',
    iso2: 'pr',
    dialCode: '1',
  },
  qa: {
    name: 'Qatar',
    iso2: 'qa',
    dialCode: '974',
  },
  re: {
    name: 'Réunion',
    iso2: 're',
    dialCode: '262',
  },
  ro: {
    name: 'Romania',
    iso2: 'ro',
    dialCode: '40',
  },
  ru: {
    name: 'Russia',
    iso2: 'ru',
    dialCode: '7',
  },
  rw: {
    name: 'Rwanda',
    iso2: 'rw',
    dialCode: '250',
  },
  bl: {
    name: 'Saint Barthélemy',
    iso2: 'bl',
    dialCode: '590',
  },
  sh: {
    name: 'Saint Helena',
    iso2: 'sh',
    dialCode: '290',
  },
  kn: {
    name: 'Saint Kitts and Nevis',
    iso2: 'kn',
    dialCode: '1869',
  },
  lc: {
    name: 'Saint Lucia',
    iso2: 'lc',
    dialCode: '1758',
  },
  mf: {
    name: 'Saint Martin',
    iso2: 'mf',
    dialCode: '590',
  },
  pm: {
    name: 'Saint Pierre and Miquelon',
    iso2: 'pm',
    dialCode: '508',
  },
  vc: {
    name: 'Saint Vincent and the Grenadines',
    iso2: 'vc',
    dialCode: '1784',
  },
  ws: {
    name: 'Samoa',
    iso2: 'ws',
    dialCode: '685',
  },
  sm: {
    name: 'San Marino',
    iso2: 'sm',
    dialCode: '378',
  },
  st: {
    name: 'São Tomé and Príncipe',
    iso2: 'st',
    dialCode: '239',
  },
  sa: {
    name: 'Saudi Arabia',
    iso2: 'sa',
    dialCode: '966',
  },
  sn: {
    name: 'Senegal',
    iso2: 'sn',
    dialCode: '221',
  },
  rs: {
    name: 'Serbia',
    iso2: 'rs',
    dialCode: '381',
  },
  sc: {
    name: 'Seychelles',
    iso2: 'sc',
    dialCode: '248',
  },
  sl: {
    name: 'Sierra Leone',
    iso2: 'sl',
    dialCode: '232',
  },
  sg: {
    name: 'Singapore',
    iso2: 'sg',
    dialCode: '65',
  },
  sx: {
    name: 'Sint Maarten',
    iso2: 'sx',
    dialCode: '1721',
  },
  sk: {
    name: 'Slovakia',
    iso2: 'sk',
    dialCode: '421',
  },
  si: {
    name: 'Slovenia',
    iso2: 'si',
    dialCode: '386',
  },
  sb: {
    name: 'Solomon Islands',
    iso2: 'sb',
    dialCode: '677',
  },
  so: {
    name: 'Somalia',
    iso2: 'so',
    dialCode: '252',
  },
  za: {
    name: 'South Africa',
    iso2: 'za',
    dialCode: '27',
  },
  kr: {
    name: 'South Korea',
    iso2: 'kr',
    dialCode: '82',
  },
  ss: {
    name: 'South Sudan',
    iso2: 'ss',
    dialCode: '211',
  },
  es: {
    name: 'Spain',
    iso2: 'es',
    dialCode: '34',
  },
  lk: {
    name: 'Sri Lanka',
    iso2: 'lk',
    dialCode: '94',
  },
  sd: {
    name: 'Sudan',
    iso2: 'sd',
    dialCode: '249',
  },
  sr: {
    name: 'Suriname',
    iso2: 'sr',
    dialCode: '597',
  },
  sz: {
    name: 'Swaziland',
    iso2: 'sz',
    dialCode: '268',
  },
  se: {
    name: 'Sweden',
    iso2: 'se',
    dialCode: '46',
  },
  ch: {
    name: 'Switzerland',
    iso2: 'ch',
    dialCode: '41',
  },
  sy: {
    name: 'Syria',
    iso2: 'sy',
    dialCode: '963',
  },
  tw: {
    name: 'Taiwan',
    iso2: 'tw',
    dialCode: '886',
  },
  tj: {
    name: 'Tajikistan',
    iso2: 'tj',
    dialCode: '992',
  },
  tz: {
    name: 'Tanzania',
    iso2: 'tz',
    dialCode: '255',
  },
  th: {
    name: 'Thailand',
    iso2: 'th',
    dialCode: '66',
  },
  tl: {
    name: 'Timor-Leste',
    iso2: 'tl',
    dialCode: '670',
  },
  tg: {
    name: 'Togo',
    iso2: 'tg',
    dialCode: '228',
  },
  tk: {
    name: 'Tokelau',
    iso2: 'tk',
    dialCode: '690',
  },
  to: {
    name: 'Tonga',
    iso2: 'to',
    dialCode: '676',
  },
  tt: {
    name: 'Trinidad and Tobago',
    iso2: 'tt',
    dialCode: '1868',
  },
  tn: {
    name: 'Tunisia',
    iso2: 'tn',
    dialCode: '216',
  },
  tr: {
    name: 'Turkey',
    iso2: 'tr',
    dialCode: '90',
  },
  tm: {
    name: 'Turkmenistan',
    iso2: 'tm',
    dialCode: '993',
  },
  tc: {
    name: 'Turks and Caicos Islands',
    iso2: 'tc',
    dialCode: '1649',
  },
  tv: {
    name: 'Tuvalu',
    iso2: 'tv',
    dialCode: '688',
  },
  vi: {
    name: 'U.S. Virgin Islands',
    iso2: 'vi',
    dialCode: '1340',
  },
  ug: {
    name: 'Uganda',
    iso2: 'ug',
    dialCode: '256',
  },
  ua: {
    name: 'Ukraine',
    iso2: 'ua',
    dialCode: '380',
  },
  ae: {
    name: 'United Arab Emirates',
    iso2: 'ae',
    dialCode: '971',
  },
  gb: {
    name: 'United Kingdom',
    iso2: 'gb',
    dialCode: '44',
  },
  us: {
    name: 'United States',
    iso2: 'us',
    dialCode: '1',
  },
  uy: {
    name: 'Uruguay',
    iso2: 'uy',
    dialCode: '598',
  },
  uz: {
    name: 'Uzbekistan',
    iso2: 'uz',
    dialCode: '998',
  },
  vu: {
    name: 'Vanuatu',
    iso2: 'vu',
    dialCode: '678',
  },
  va: {
    name: 'Vatican City',
    iso2: 'va',
    dialCode: '39',
  },
  ve: {
    name: 'Venezuela',
    iso2: 've',
    dialCode: '58',
  },
  vn: {
    name: 'Vietnam',
    iso2: 'vn',
    dialCode: '84',
  },
  wf: {
    name: 'Wallis and Futuna',
    iso2: 'wf',
    dialCode: '681',
  },
  ye: {
    name: 'Yemen',
    iso2: 'ye',
    dialCode: '967',
  },
  zm: {
    name: 'Zambia',
    iso2: 'zm',
    dialCode: '260',
  },
  zw: {
    name: 'Zimbabwe',
    iso2: 'zw',
    dialCode: '263',
  },
};

const CountriesData = () => {
  const context = require.context('../images/flags', true, /\.svg/);
  context.keys().map((file) => {
    const countryCode = file.match(/\.\/([a-z]+)\.svg/)[1];
    if (RawCountriesData[countryCode]) {
      RawCountriesData[countryCode].flag = context(file);
    }
    return file;
  });
  return RawCountriesData;
};

export default CountriesData();
